'use client';

import cn from 'classnames';
import type { ReactElement } from 'react';
import { useCookie } from 'react-use';
import { Collapse } from 'transitions-kit';
import css from './devtools.module.scss';

type Props = {
    children: ReactElement;
    initial?: string;
};
export function Fold({ children, initial = '0' }: Props) {
    const [open, setOpen] = useCookie('x-petm-devtools');
    const isOpen = (open || initial) === '1';

    return (
        <div className={css.devtool}>
            <Collapse in={isOpen} mountOnEnter unmountOnExit>
                {children}
            </Collapse>
            <button
                type="button"
                className={cn(css.icon, { [css.open]: open })}
                onClick={() => setOpen(isOpen ? '0' : '1')}
            >
                <span>⚙️</span>
            </button>
        </div>
    );
}
